module.exports = __webpack_public_path__ + "static/media/des-expectations.52fbd310.png";